<template>
  <!--注册-->
  <div class="register">
    <mt-header title="注册" style="height:8vh;font-size:18px;">
      <router-link to="/passport/login" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
     <div class="content_wrap">
       <div class="content" ref="minContent">

         <!--第二步-->
         <div class="part_two" ref="part_two">
           <div class="chooseRole">
              <div class="chooseRole-choose">
                <div @click="chooseIdentity(0)" :class="{'identity':true,'activeIdentity':!activeIdentity}">
                  <div>我是雇主</div>
                  <div>我要找人办事</div>
                </div>
                <div @click="chooseIdentity(1)" :class="{'identity':true,'activeIdentity':activeIdentity}">
                  <div>我是服务商</div>
                  <div>我要入驻赚钱</div>
                </div>
              </div>
            </div>
           <!--表单部分-->
           <form class="from_group" @submit.prevent="validateSubmitTwo('form-2')" data-vv-scope="form-2">
            <!-- 手机号 -->
             <div class="input_group">
                <input pattern="[0-9]*" type="tel" name="phone" ref="phone" v-model="phone" placeholder="请输入手机号" v-validate="'required|phone'" :class="{'input': true, 'is-danger': errors.has('phone') }" @input="phoneChange">
                <button :class="{'sendCode':true, 'sendCodeDisable':sendCodeDisable, 'is-danger': errors.has('phone')}" type="button" ref="getCode" @click="countDown()">获取验证码</button>
             </div>
             <span v-show="errors.has('form-2.phone')" class="help is-danger">{{ errors.first('form-2.phone') }}</span>
             <div class="jisu"  id="captcha"></div>
            <!-- 短信验证 -->
             <div class="input_group">
               <input pattern="[0-9]*" type="number" id="codeVal" ref="code" name="code" v-model="code" placeholder="请输入验证码" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('code') }" @input="codeChange">
             </div>
             <span v-show="errors.has('form-2.code')" class="help is-danger">{{ errors.first('form-2.code') }}</span>
            <!-- 设置密码 -->
            <div class="input_group">
              <input style="width:90%;" type="password" ref="pw" name="password" v-model="password" placeholder="请设置密码，6-16位数字或字母" v-validate="'required|password'" :class="{'input': true, 'is-danger': errors.has('password') }" @input="passwordChange">
              <!-- <icon name="eye" class="look" :class="{'lookType':!lookType}" @click.native="seePw()"></icon> -->
            </div>
            <span v-show="errors.has('form-2.password')" class="help is-danger">{{ errors.first('form-2.password') }}</span>



             <div class="submitPart">
               <button type="submit" class="register" :disabled="!dis">注册</button>
             </div>
           </form>
           <div class="agree">
             <span>注册代表您已同意</span>
             <span class="agreement" @click="handleClick">《用户协议》</span>
           </div>
         </div>
       </div>
     </div>
     <!--用户协议-->
     <mt-popup v-model="popupVisible" position="right" id="alert">
       <div>
         <mt-header title="用户协议">
           <div slot="left">
              <mt-button icon="back" @click.native="closeAlert">返回</mt-button>
           </div>
         </mt-header>
         <pre ref='contract' class="contract"></pre>
       </div>
     </mt-popup>
  </div>
</template>
<script>

import Geetest from '../assets/js/gt'
import { Toast, Indicator } from 'mint-ui'//引入弹框
import bus from '../utiles/bus'
var captcha = null
export default {
  name: 'register',
  data () {
    return {
      userName: '',
      password: '',
      phone: '',
      code: '',
      lookType: 'false',
      dis: 'false',
      time: '60',
      popupVisible: false,
      tmpGeetest: Geetest,
      canGet: true
      // canGet: false
      ,
      // 注册单选
      activeIdentity:false,
      iwant:0,
      sendCodeDisable:false
    }
  },
  mounted () {
    this.initGeetested()
  },
  methods: {
    initGeetested () {
      var _this = this
      this.axios.get('/url/common/fastRegister?t=' + (new Date()).getTime())
      .then(function (data) {
        window.initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captcha = captchaObj
          captchaObj.onReady(function () {
            // console.log('onReady==========')
          }).onSuccess(function () {
            var result = captchaObj.getValidate()
            if (result) {
              _this.registered(result)
              // console.log(result)
              // _this.getCodeFromBack(result)
            } else {
              alert('验证失败')
            }
          })
        })
      })
    },
    registered(result){
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/account/checkPhone',
        params: {
          phone: this.phone
        }
      }).then(function (res) {
        // console.l(res.data)
          let msg = ''
        if (res.data.success) {
          _this.getCodeFromBack(result)
        }else{
          msg = res.data.msg
        }
        // 提示框
        Toast({
          message: msg,
          position: 'middle',
          duration: 2000
        })
      })
    },
    validateSubmitTwo (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.register()
        }
      })
    },

    disabled () {
      this.dis = !this.dis
    },
    register () {
      Indicator.open({
        text: '注册中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/register/register',
        params: {
          password: this.password,
          phone: this.phone,
          // username: this.userName,
          wishRole:Number(_this.iwant),
          message: this.code
        }
      }).then(function (response) {
        Indicator.close()
        let msg = ''
        if (response.data.success === true) {
          _this.STATE.state.loginState = true
          _this.STATE.state.loginPhone = _this.phone
          _this.STATE.state.loginId = response.data.data.loginID
          msg = '注册成功'
          _this.$router.push({path: '/'})
          bus.$emit('routerBus', 'btnOne')
          _this.STATE.commit('setloginId',response.data.data.loginID)
        } else {
          _this.STATE.state.loginState = false
          msg = response.data.msg
        }
        Toast({
          message: msg,
          position: 'middle',
          duration: 1000
        })
      }).catch(function (response) {
        Indicator.close()
        _this.STATE.state.loginState = false
        Toast({
          message: '注册失败',
          position: 'middle',
          duration: 1000
        })
      })
    },
    seePw () {
      if (this.$refs.pw.type === 'password') {
        this.$refs.pw.type = 'text'
        this.lookType = false
      } else {
        this.$refs.pw.type = 'password'
        this.lookType = true
      }
    },
    countDown: function () {
      this.$refs.phone.focus();
      this.$refs.phone.blur();        
      if(this.canGet ===false){
          captcha.verify()
      }
    },
    // 发送验证码
    getCodeFromBack: function (result) {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/common/getWechatVerificationCode/1',
        params: {
          moblie: this.phone,
          challenge: result.geetest_challenge,
          validate: result.geetest_validate,
          seccode: result.geetest_seccode
        }
      }).then(function (response) {
        let msg = ''
        if (response.data.success) {
          msg = '发送成功'
          _this.runCode()
        } else {
          msg = response.data.msg
        }
        Toast({
          message: msg,
          position: 'middle',
          duration: 1000
        })
      }).catch(function (response) {
        Toast({
          message: '发送失败',
          position: 'middle',
          duration: 1000
        })
      })
    },
    runCode: function () {
      if (this.time === 0) {
        this.sendCodeDisable = false
        this.$refs.getCode.removeAttribute('disabled')
        this.$refs.getCode.innerHTML = '获取验证码'
        this.time = 60
      } else {
        this.sendCodeDisable = true
        this.$refs.getCode.setAttribute('disabled', true)
        this.$refs.getCode.innerHTML = this.time + '秒后获取'
        this.time --
        setTimeout(this.runCode, 1000)
      }
    },
    handleClick: function () {
      let _this = this
      this.axios({
        method: 'post',
        url: 'http://blog.yunzhitu.com/agreement/feed/json',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        _this.popupVisible = true
        _this.$refs.contract.innerHTML = res.data.items[0].content_html
        // console.log(_this.items)
      })
    },
    closeAlert: function () {
      this.popupVisible = false
    },
    phoneChange: function () {
      var reg = /^((13[0-9])|(14[0-9])|(15[^4,\D])|(18[0,0-9])|(17[0-9])|(19[0-9]))\d{8}$/i
      var bol = reg.test(this.phone)
      if (bol) {
        this.canGet = false
      } else {
        this.canGet = true
      }
      this.phone = this.phone.substr(0,11)
    },
    codeChange: function () {
      this.code = this.code.substr(0,6)
    },
    passwordChange: function () {
      this.password = this.password.substr(0,16)
    },
    // 单选
    chooseIdentity(ident){
      this.iwant = ident
      if( ident == 0 ){
        this.activeIdentity = false
      }else if(ident == 1){
        this.activeIdentity = true
      }
    }
  }
}
</script>

<style scoped>
.content_wrap{
  width:100%;
  height:100%;
  overflow:hidden;
  margin-bottom:80px;
}
.content{
  width:200%;
  height:100%;
  position:relative;
  overflow:hidden;
  animation-fill-mode:forwards;
  -webkit-animation-fill-mode:forwards;
}
.part_one,.part_two{
  width:50%;
  float:left;
}
.from_group{
  /* margin-top:85px; */
  padding:0 10%;
}
.input_group{
  line-height:40px;
  margin:5px 0;
  border-bottom:1px solid #d9dedf;
}
.input_group .icon{
  margin:0 5px;
  color:#7f8b98;
}
.input_group input{
  /* margin-left:10px; */
  outline:none;
  width:60%;
  border: none;
}
.input_group input::-webkit-input-placeholder{
    color: #b7c3ca;
  }
  .input_group input:-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input::-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input:-ms-input-placeholder{
  　color:#b7c3ca;
  }
.look{
  float:right;
  color:#7f8b98;
  margin-top:10px;
  margin-right:5px;
}
.next{
  text-align:center;
}
button[type=submit],.previous{
  width:100%;
  line-height:40px;
  font-size:16px;
  -webkit-border-radiu:20px;
  -moz-border-radiu:20px;
  border-radius:8px;
  border:none;
  outline:none;
  padding:0;
  color:#fff;
  background-color:#108ee9;
}
.next button{
  margin-top:36px;
  margin-bottom:18px;
}
.next p,.next p a{
  font-size:14px;
  color:#108ee9;
}
.third-party{
  margin-top:25%;
  text-align:center;
}
.third-party .title{
  width:80%;
  margin:0 auto;
}
.third-party .title img{
  width:100%;
}
.third-party ul{
  display:inline-block;
  margin-top:25px;
  overflow:hidden;
}
.third-party ul li{
  width:43px;
  height:43px;
  float:left;
  margin:0 25px;
}
.third-party ul li img{
  width:100%;
  height:100%;
}
.sendCode{
  color:#fff;
  background-color:#108ee9;
  border:none;
  outline:none;
  height:30px;
  -webkit-border-radiu:5px;
  -moz-border-radiu:5px;
  border-radius:5px;
  float:right;
  margin-top:5px;
  line-height: 30px;
}
.sendCodeDisable{
  background-color:#c5c5c5;
  color: #666;
}
#codeVal{
  width:50%;
  margin-left:0;
}
.previous{
  color:#108ee9;
  background-color:#dcecfe;
  margin:30px 0 13px;
}
.submitPart{
  margin:30px 0 12px;
}
.agree{
  /* text-align:center; */
  margin-left: 10%;
}
.agree span{
  font-size:14px;
}
.agree a{
  color:#108ee9;
  font-size:14px;
}
.lookType{
  color:#108ee9!important;
}
.help{
  display:block;
  width:80%;
  margin:0 auto;
  font-size:14px;
  color:red;
}

@-webkit-keyframes "nextPage"{
	0%{
		left:0;
		}
	100%{left:-100%;}
}
@keyframes "nextPage"{
	0%{
		left:0;
		}
	100%{left:-100%;}
}
@-webkit-keyframes "prevPage"{
	0%{
		left:-100%;
		}
	100%{left:0;}
}
@keyframes "prevPage"{
	0%{
		left:100%;
		}
	100%{left:0;}
}
.agreement{
  color:#108ee9;
  text-decoration: underline;
}
pre{
  white-space: pre-wrap;
  word-wrap: break-word;
  padding:0 10px;
}
.mint-popup mint-popup-right{
  width:100%;
  height:100%;
}
#alert{
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
#alert h1{
  font-size:20px;
  text-align:center;
  margin-top:18px;
}
.weixinBtn{
  display: block;
  width: 100%;
  height:40px;
  font-size: 16px;
  padding: 0;
  border:none;
  outline: none;
  color: #fff;
  background-color:#32cd32;
  -webkit-border-radiu:20px;
  -moz-border-radiu:20px;
  border-radius:20px;
  margin-top: 0!important;
}
.part_one .from_group{
  margin-top: 30px;
}
.logo{
    text-align:center;
    margin-top:45px;
  }
 .logo img{
    width:105px;
  }

  /* 单选 */
.chooseRole{
    width: 100%;
    margin-top: 10px;
    padding: 10px 0;
}
.chooseRole-choose{
  display: flex;
  padding: 0 10%;
  justify-content: space-between;
}
.identity{
  width: 35vw;
  padding-top: 2vw;
  height: 14vw;
  box-shadow: 0 0 5px #888;
  text-align: center;
  border-radius: 8px;
}
.activeIdentity{
  background: #108ee9;
  color: #fff;
}
.identity div:nth-child(1){
  font-size: 18px;
  font-weight: bold;
}
.identity div:nth-child(2){
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// register.vue?159a5fda